import { Alert, Badge } from "@/shared/components/MDX/MDXComponents";

# 📋 راهنمای مدیریت لیست سفارشات تولید

پلتفرم کارخانه‌سازی میمزاد (Mimzad Manufacturing Platform) — سند راهنمای کاربری سفارشات تولید

<Badge type="gold">سند استاندارد کاربری</Badge> <Badge>راهنمای جامع</Badge>

## 📋 فهرست مطالب و دسترسی سریع

1. [مقدمه و نمای کلی](#sec-intro)
2. [جستجو و فیلترها](#sec-step1)
3. [گزارش‌گیری و خروجی‌ها](#sec-step2)
4. [معنی وضعیت‌های سفارش](#sec-step3)

---

## 1. مقدمه و نمای کلی

در بخش **سفارشات تولید (Production Orders)**، شما می‌توانید تمام دستورکارهای تولیدی صادرشده به سطح کارگاه را مشاهده، ردیابی و مدیریت کنید.
این صفحه به عنوان یک «مرکز کنترل» (Control Tower) برای سرپرستان تولید عمل می‌کند و امکان پایش درلحظه‌ی سفارشات جاری، فوری و متوقف‌شده را فراهم می‌آورد.

<Alert type="info">
  **شاخص‌های کلیدی (KPI):** در بالای صفحه، وضعیت لحظه‌ای سفارشات شامل تعداد سفارشات جاری، فوری، توقف‌خورده و پایان‌یافته به‌صورت خلاصه نمایش داده می‌شود.
</Alert>

---

## 2. جستجو و فیلترها

برای پیدا کردن یک سفارش خاص، ابزارهای مختلفی در دسترس شماست:

1. **نوار جستجوی سریع:** می‌توانید شماره سفارش، نام محصول یا کد آن را وارد کنید.
2. **فیلترهای تب‌بندی شده:** با کلیک روی تب‌های بالای جدول (مانند `فوری`، `جاری`، `توقف‌خورده`) لیست به صورت آنی فیلتر می‌شود.
3. **فیلترهای پیشرفته:** می‌توانید بر اساس تاریخ ایجاد، موعد تحویل یا دپارتمان خاص فیلترها را ترکیب کنید.

---

## 3. گزارش‌گیری و خروجی‌ها

در صورتی که نیاز به چاپ یا تحلیل لیست سفارشات در نرم‌افزارهای دیگر دارید، از دکمه‌های خروجی در بالای جدول استفاده کنید:

- **خروجی Excel (XLSX):** مناسب برای دریافت خروجی ساختاریافته، تحلیل داده در اکسل و ارسال به سایر دپارتمان‌ها.
- **خروجی PDF:** مناسب برای چاپ لیست کارها جهت نصب در تابلوی اعلانات سالن تولید یا آرشیو اسناد.

<Alert type="warning">
  چنانچه تعداد رکوردهای یافت‌شده بیش از ۱۰,۰۰۰ مورد باشد، به دلیل محدودیت‌های حافظه، فایل خروجی محدود به ۱۰,۰۰۰ رکورد اول خواهد بود. در این حالت بهتر است از فیلتر تاریخ استفاده نمایید.
</Alert>

---

## 4. معنی وضعیت‌های سفارش

هر سفارش تولید در چرخه‌ی عمر خود از وضعیت‌های گوناگونی عبور می‌کند:

| عنوان وضعیت | کد سیستم | توضیحات و کاربرد |
| :--- | :--- | :--- |
| **پیش‌نویس (Draft)** | `draft` | سفارش ایجاد شده اما هنوز برای اجرا به کارگاه ابلاغ نشده است. |
| **آزاد شده (Released)** | `released` | سفارش برای تولید ابلاغ شده و آماده‌ی شروع در ایستگاه اول است. |
| **در حال اجرا (In Progress)** | `in_progress` | فرآیند تولید سفارش در ایستگاه‌های کاری در جریان است. |
| **توقف‌خورده (On Hold)** | `on_hold` | سفارش به دلیل کمبود قطعه، خرابی ماشین یا دستور کیفی متوقف شده است. |
| **پایان‌یافته (Completed)** | `completed` | تمام مراحل تولید به پایان رسیده و سفارش تحویل انبار یا مشتری شده است. |
